"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
//@ts-nocheck
const gen5_shared_utilities_1 = require("@terragotech/gen5-shared-utilities");
const react_1 = __importStar(require("react"));
const TGPageLabelWrapper_1 = __importDefault(require("./TGPageLabelWrapper"));
const clsx_1 = __importDefault(require("clsx"));
const Common_1 = require("../../components/FormFields/Common");
const core_1 = require("@material-ui/core");
const styles_1 = require("@material-ui/core/styles");
const configContext_1 = require("../../contexts/configContext");
const date_fns_1 = __importDefault(require("@date-io/date-fns"));
const pickers_1 = require("@material-ui/pickers");
const TGPageDateInputField = props => {
    const { readOnly, warning, computed, oneLine, translateFunction } = props;
    const classes = (0, Common_1.useStyles)();
    const [tooltip, setTooltip] = (0, react_1.useState)(false);
    const theme = (0, core_1.useTheme)();
    const { defaultDateTimeFormat } = (0, configContext_1.useConfig)();
    const calendarTheme = (0, styles_1.createTheme)({
        palette: {
            primary: {
                main: theme.palette.primary.main,
            },
            info: {
                main: theme.palette.primary.main,
            },
        },
    });
    const label = (react_1.default.createElement(TGPageLabelWrapper_1.default, { required: props.required, readOnly: readOnly, label: props.label, info: props.info, calculated: computed, oneLine: oneLine, translateFunction: translateFunction }));
    return (react_1.default.createElement(pickers_1.MuiPickersUtilsProvider, { utils: date_fns_1.default },
        react_1.default.createElement(core_1.ThemeProvider, { theme: calendarTheme },
            label,
            react_1.default.createElement(pickers_1.DatePicker, Object.assign({ fullWidth: true, InputLabelProps: {
                    shrink: true,
                    className: (0, clsx_1.default)(classes.labelShrink, warning && classes.warningText),
                }, style: { marginTop: 0, marginBottom: 0 }, margin: "normal" }, props, { format: (0, gen5_shared_utilities_1.getDateFormat)(defaultDateTimeFormat === null || defaultDateTimeFormat === void 0 ? void 0 : defaultDateTimeFormat.dateFormatType, defaultDateTimeFormat === null || defaultDateTimeFormat === void 0 ? void 0 : defaultDateTimeFormat.dateFormat, defaultDateTimeFormat === null || defaultDateTimeFormat === void 0 ? void 0 : defaultDateTimeFormat.dateSeperator, {
                    tokenConversion: gen5_shared_utilities_1.DATETIME_TOKEN_CONVERSION.MuiPicker,
                    datePartOnly: true,
                }), label: null, required: false, disabled: readOnly, clearable: true, FormHelperTextProps: { className: (0, clsx_1.default)(warning && classes.warningText) }, 
                // We want the Tooltip to be triggered on field hovering, but positioned relative to the label
                onMouseEnter: () => readOnly && setTooltip(true), onMouseLeave: () => readOnly && setTooltip(false) })))));
};
exports.default = TGPageDateInputField;
//# sourceMappingURL=TGPageDateInputField.js.map